<div class="container flex w-full flex-col flex-wrap pb-12">
  <rd-shared-breadcrumb
    [breadcrumbText]="'transfer_v2.review.back_to_checkout' | translate"
    [redirectURL]="checkoutPageUrl.url"
    [queryParams]="checkoutPageUrl.queryParams"
    [displayModeDesktop]="'stacked'"
    [displayModeMobile]="'stacked'">
  </rd-shared-breadcrumb>

  <ng-container
    *ngIf="
      (loyaltyProgramMembership$ | async) && (loyaltyProgram$ | async);
      else loading
    ">
    <rd-tcv2-review-body
      [formData]="checkoutFormData$ | async"
      [loyaltyProgram]="loyaltyProgram$ | async"
      [membership]="loyaltyProgramMembership$ | async"
      [promocode]="promocode$ | async"
      [pointsTransferLoading]="false">
    </rd-tcv2-review-body>

    <div class="promocode-container" *ngIf="hasPromocode">
      <rd-promocode-ui
        [promocodeLoading]="promocodeLoading$ | async"
        [promocode]="promocode$ | async"
        [promocodeUsage]="promocodeUsage$ | async"
        [promocodeHttpError]="promocodeError$ | async"
        (applyPromocode)="handleApplyPromocode($event)"></rd-promocode-ui>
    </div>

    <rd-tcv2-review-form
      class="mt-4 flex lg:mt-6"
      [loyaltyProgram]="loyaltyProgram$ | async"
      [pointsTransferLoading]="pointsTransferLoading$ | async"
      [promocodeLoading]="promocodeLoading$ | async"
      (submitEvent)="submitPointsTransfer()">
    </rd-tcv2-review-form>
  </ng-container>

  <ng-template #loading>
    <div class="my-6 grid h-16 w-full place-items-center">
      <rd-shared-spinner></rd-shared-spinner>
    </div>
  </ng-template>
</div>
